import { BrowserMeasurements } from './browserMeasurements';

const getBrowserSizes = (browserSize: BrowserMeasurements): BrowserMeasurements =>
    browserSize && {
        browserWidth: browserSize.browserWidth,
        browserHeight: browserSize.browserHeight,
        screenWidth: browserSize.screenWidth,
        screenHeight: browserSize.screenHeight,
        screenPixelRatio: browserSize.screenPixelRatio,
    };

type Statistics = {
    orvestoData: string;
    dataLake: {
        content?: {
            id: string;
        };
        product: {
            viewId: string;
            viewType: string;
        };
        eventValues: BrowserMeasurements;
    };
};

export const createStartPageStatistics = (
    viewId: string,
    viewType: string,
    browserSize: BrowserMeasurements = null
): Statistics => ({
    orvestoData: '/forstasida/lop/index',
    dataLake: {
        product: {
            viewId,
            viewType,
        },
        eventValues: getBrowserSizes(browserSize),
    },
});

export const createVideoStatistics = (
    titleSlug: string,
    episodeTitleSlug: string,
    svtId: string,
    viewId: string = null,
    viewType: string = null,
    browserSize: BrowserMeasurements = null
): Statistics => ({
    orvestoData: `/program/${titleSlug}/${episodeTitleSlug}`,

    dataLake: {
        content: {
            id: svtId,
        },
        product: {
            viewId,
            viewType,
        },
        eventValues: getBrowserSizes(browserSize),
    },
});

export const createTitleStatistics = (
    titleSlug: string,
    svtId: string,
    viewId: string = null,
    viewType: string = null,
    browserSize: BrowserMeasurements = null
): Statistics => ({
    orvestoData: `/program/${titleSlug}/index`,

    dataLake: {
        content: {
            id: svtId,
        },
        product: {
            viewId,
            viewType,
        },
        eventValues: getBrowserSizes(browserSize),
    },
});

export const createGenreStatistics = (
    slug: string,
    viewId: string = null,
    viewType: string = null,
    browserSize: BrowserMeasurements = null
): Statistics => ({
    orvestoData: `/${slug}/lop/index`,
    dataLake: {
        content: {
            id: slug,
        },
        product: {
            viewId,
            viewType,
        },
        eventValues: getBrowserSizes(browserSize),
    },
});
